import React, { useState } from "react";
import { upsert } from "../firebase";
import { Form, Input, Button, message, Modal } from "antd";

interface NewsletterType {
  email: string;
}

const Newsletter: React.FC = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setLoading(false);
    form.resetFields();
  };

  const handleSubmit = async (values: NewsletterType) => {
    setLoading(true);
    try {
        await upsert("newsletter", values.email, {
          subscribed: true,
        });
      } catch (err) {
      message.error("Une erreur est survenue, veuillez réessayer.");
    }
    handleCloseModal();
    message.success("Vous êtes maintenant abonné à la newsletter!");
  };

  return (
    <div>
      <Button ghost onClick={handleOpenModal}>
        S'abonner à la newsletter
      </Button>

      <Modal
        title="Abonnement à la newsletter"
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            email: "",
          }}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Email requis!" },
              { type: "email", message: "Email invalide!" },
            ]}
          >
            <Input placeholder="Entrez votre email" />
          </Form.Item>

            <Button loading={loading} type="primary" htmlType="submit">
              S'abonner
            </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default Newsletter;
